import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useState } from "react";
import { useMedia } from "react-use";
import { useTranslations } from "next-intl";
import { Theme, Ui } from "@silvertours/front-shared";
var Error = function(param) {
    var statusCode = param.statusCode;
    var t = useTranslations("features.stageLegacy.stage");
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), false);
    var ref = useState(true), showModal = ref[0], setShowModal = ref[1];
    var handleHideModal = function() {
        setShowModal(false);
    };
    var messageProps = {
        404: {
            headline: t("errors.404.title"),
            children: t("errors.404.text")
        },
        500: {
            headline: t("errors.500.title"),
            children: t("errors.500.text")
        },
        503: {
            headline: t("errors.503.title"),
            children: t("errors.503.text")
        }
    };
    var hasError = statusCode ? Object.keys(messageProps).includes(statusCode.toString()) : false;
    if (!statusCode || !hasError) {
        return null;
    }
    if (isMobile) {
        if (showModal) {
            var _statusCode = messageProps[statusCode], headline = _statusCode.headline, children = _statusCode.children;
            return /*#__PURE__*/ _jsx(Ui.Overlay, {
                title: headline,
                open: showModal,
                onClose: handleHideModal,
                children: /*#__PURE__*/ _jsx(Ui.Message, {
                    severity: Ui.MessageSeverity.ERROR,
                    role: Ui.MessageRole.ALERT,
                    children: children
                })
            });
        }
        return null;
    }
    return /*#__PURE__*/ _jsx(Ui.Message, _object_spread({
        severity: Ui.MessageSeverity.ERROR,
        role: Ui.MessageRole.ALERT
    }, messageProps[statusCode]));
};
export { Error };
